export function getTaskItemBackgroundColors(hasPassed: boolean, isFinished: boolean) {
    return hasPassed && !isFinished
        ?
        {
            backgroundColor: "#fee2e2",
            borderColor: "#fca5a5"
        }
        :
        {
            backgroundColor: "#f1f5f9",
            borderColor: "#d1d5db"
        }
}
